import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.comp)
    ? _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent($setup.props.comp.is), _mergeProps({ key: 0 }, $setup.props.comp.props, {
        key: $setup.props.comp.is + '-' + ($setup.props.comp.props?.clientId || 'default')
      }), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($setup.props.comp.content ? $setup.props.comp.content : "") + " ", 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.comp.children, (child, ind) => {
            return (_openBlock(), _createBlock($setup["ModalView"], {
              key: child.slot + '-' + ind,
              comp: child
            }, null, 8 /* PROPS */, ["comp"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)), [
        [$setup["vDynamicEvents"], $setup.props.comp.events || []]
      ])
    : _createCommentVNode("v-if", true)
}